export const Element = ({element}) => {
  return <h1>{ element }</h1>
}

